<template>
  <div class="active-detail">
    <common-layout>
      <div slot="header">
        <h3>活动详情</h3>
      </div>
      <div slot="container">
        <div class="active-detail.header">
          <el-button class="active-detail.addBtn" @click="$router.go(-1)"
            >返回上一页</el-button
          >
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
            :disabled="is_show == 4 || isEnroll == 2"
            style="background: #623aa2; border: none"
            >新增</el-button
          >
          <section>
            <el-input
              style="margin-right: 10px"
              placeholder="请输入内容"
              v-model="searchValue"
              class="input-with-select"
              clearable
              @change="search"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>

            <el-button
              type="success"
              class="active-detail.addBtn"
              @click="exportExcel"
              :disabled="tableData.length == 0"
              >导出</el-button
            >
            <!-- <el-button type="warning" class="active-detail.addBtn" @click="importExcel">导入</el-button> -->
          </section>
          <section>
            <span class="fz-14">报名/签到 :</span>
            <el-select
              v-model="typeStatus"
              @change="typeChange"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </section>
        </div>
        <div class="active-detail.table">
          <el-table
            :data="tableData"
            stripe
            style="width: 100%"
            :header-cell-style="headerStyle"
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="90"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (current_page - 1) * per_page + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="enrollName"
              label="参会人员姓名"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="enrollCompany"
              label="单位名称"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="enrollPosition"
              label="职务"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="enrollPhone"
              label="手机号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="enrollEmail"
              label="邮箱"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="enrollRemark"
              label="备注"
              align="center"
            ></el-table-column>
            <el-table-column label="是否报名" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.isEnroll == "1" ? "是" : "否" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="是否签到" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.isSign == "1" ? "是" : "否" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              v-if="isEndFn()"
              label="操作"
              width="180"
            >
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                  v-show="scope.row.isRegister == 2"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <div class="grid-content bg-purple-light">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next,jumper"
              :total="total"
              :current-page.sync="current_page"
              :page-size="per_page"
            ></el-pagination>
          </div>
        </div>
      </div>
    </common-layout>
    <el-dialog
      :title="title"
      :visible.sync="personVisible"
      width="30%"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form
        :model="personForm"
        :rules="personFormRule"
        label-width="80px"
        ref="personForm"
      >
        <el-form-item label="姓名" prop="enrollName">
          <el-input
            v-model="personForm.enrollName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="enrollCompany">
          <el-input
            v-model="personForm.enrollCompany"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="enrollPosition">
          <el-input
            v-model="personForm.enrollPosition"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="enrollPhone">
          <el-input
            v-model="personForm.enrollPhone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input
            v-model="personForm.enrollEmail"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="personForm.enrollRemark"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否报名" style="text-align: left">
              <el-radio-group v-model="personForm.isEnroll">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否签到" style="text-align: left">
              <el-radio-group v-model="personForm.isSign">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="personVisible = false">取 消</el-button>
        <el-button type="primary" @click="createPerson">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
import checkPhone from "../../../utils/checkPhone";
import store from "@/store";
import {download1} from "@/utils/download";
export default {
  components: {
    CommonLayout,
  },
  data() {
    return {
      is_submit: true,
      is_show: 1,
      isEnroll: 1,
      page_activeId: "",
      typeStatus: "1",
      options: [
        {
          label: "报名",
          value: "1",
        },
        {
          label: "签到",
          value: "2",
        },
      ],
      personVisible: false,
      title: "",
      searchValue: "",
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      tableData: [],
      total: 20,
      current_page: 1,
      per_page: 10,
      personForm: {
        enrollName: "",
        enrollCompany: "",
        enrollPosition: "",
        enrollPhone: "",
        enrollEmail: "",
        enrollRemark: "",
        isRegister: 2,
        isEnroll: 2,
        enrollTime: "",
        isSign: 2,
        signTime: "",
      },
      personFormRule: {
        enrollName: [
          {
            required: true,
            message: "请填写姓名",
            trigger: "blur",
          },
        ],
        enrollCompany: [
          {
            required: true,
            message: "请填写单位名称",
            trigger: "blur",
          },
        ],
        enrollPosition: [
          {
            required: true,
            message: "请填写职位名称",
            trigger: "blur",
          },
        ],
        enrollPhone: [
          {
            validator: checkPhone,
            trigger: "blur",
            required: true,
          },
        ],
      },
    };
  },
  methods: {
    // 切换 报名签到详情
    isEndFn() {
      let end_time = this.tableData[0]?.end_time || "";
      if (!end_time) {
        return true;
      }
      if (new Date().valueOf() > new Date(end_time).valueOf()) {
        return true;
      } else {
        return false;
      }
    },
    typeChange(val) {
      this.searchValue = "";
      if (val === "1") {
        this.initPersonData(`Active_Enroll?activeId=${this.$route.params.id}`);
      } else {
        this.initPersonData(`Active_Sign?activeId=${this.page_activeId}`);
      }
    },

    // 导出
    exportExcel() {
      let url = "";

      if (this.typeStatus === "1") {
        // 报名导出
        /*url =
          window.urlConfig.url +
          "active_sign/export?activeId=" +
          this.$route.params.id +
          "&table=Active_Enroll";*/
        url = `${urlConfig.devUrl}apij2/admin-api/trade/active-enroll/export-excel?activeId=` +this.$route.params.id
        download1(url, '报名名单.xls');
      } else {
        // 签到导出
        /*url =
          window.urlConfig.url +
          "active_sign/export?activeId=" +
          this.$route.params.id +
          "&table=Active_Sign";*/
        url = `${urlConfig.devUrl}apij2/admin-api/trade/active-sign/export-excel?activeId=` +this.$route.params.id
        download1(url, '签到名单.xls')
      }

      /*const token = store.state.userInfo && JSON.parse(store.state.userInfo).token;
      const headers = new Headers();
      headers.append('Authorization', token); // 设置授权头，替换YourAccessToken为实际的访问令牌
      // 发起 Fetch 请求
      fetch(url, {
        method: 'GET',
        headers: headers,
      }).then(response => response.blob())
          .then(blob => {
            // 创建一个虚拟的链接元素，模拟点击下载
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = '报名名单.xls'; // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
            document.body.appendChild(link);

            link.click();
            document.body.removeChild(link);
          }).catch(error => {
            console.error('Error:', error);
          });*/

      // console.log("下载地址", url);
      /*var a = document.createElement("a");
      a.href = url;
      a.download = "";
      a.click();*/
    },
    //导入
    importExcel() {},
    //新增
    add() {
      this.title = "新建";
      this.personVisible = true;
      this.personForm = {
        activeId: this.$route.params.id,
        enrollName: "",
        enrollCompany: "",
        enrollPosition: "",
        enrollPhone: "",
        enrollEmail: "",
        enrollRemark: "",
        isRegister: 2,
        isEnroll: 2,
        enrollTime: "",
        isSign: 2,
        signTime: "",
      };
    },
    //编辑
    handleEdit(index, row) {
      this.title = "编辑";
      this.personVisible = true;
      this.personForm = JSON.parse(JSON.stringify(row));
      this.personForm.activeId = this.$route.params.id;
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          // console.log(row.id);
          let url = '';
          if(this.typeStatus === "1"){
            url = `${urlConfig.devUrl}apij2/admin-api/trade/active-enroll/delete?id=`;
          }else{
            url = `${urlConfig.devUrl}apij2/admin-api/trade/active-sign/delete?id=`;
          }

          this.http
            .request(url+row.id, "", "delete")
            .then((res) => {
              if (res.code == 0) {
                this.ResetSearch(["searchValue"]);
                this.initPersonData(
                  `Active_Enroll?activeId=${this.$route.params.id}`
                );
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //提交
    createPerson() {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.$refs["personForm"].validate((valid) => {
        if (valid) {
          if (this.personForm.isEnroll == 2 && this.personForm.isSign == 2) {
            this.$message.error("报名状态和签到状态不能同时为否");
            this.is_submit = true;
          } else {
            if (!this.personForm.id) {
              let params = {
                enrollName: this.personForm.enrollName,
                enrollCompany: this.personForm.enrollCompany,
                enrollPosition: this.personForm.enrollPosition,
                enrollPhone: this.personForm.enrollPhone,
                enrollEmail: this.personForm.enrollEmail,
                enrollRemark: this.personForm.enrollRemark,
                activeId: this.personForm.activeId,
                isRegister: this.personForm.isRegister,
                isEnroll: this.personForm.isEnroll,
                enrollTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
                isSign: this.personForm.isSign,
                signTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
              };
              if (params.isEnroll == 2) {
                delete params.enrollTime;
              }
              if (params.isSign == 2) {
                delete params.signTime;
              }
              if (params.isEnroll == 1) {
                this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/active-enroll/create`, params).then((res) => {
                  if (res.code == 0) {
                    this.ResetSearch(["searchValue"]);
                    this.$message.success("报名成功");
                    this.personVisible = false;
                    this.initPersonData(
                      `Active_Enroll?activeId=${this.$route.params.id}`
                    );
                  } else {
                    this.$message.error(res.status);
                  }
                });
              }
              if (params.isSign == 1) {
                // let sign = {};
                // sign.activeId = params.activeId;
                // sign.isEnroll = params.isEnroll;
                // sign.enrollPhone = params.enrollPhone;
                // sign.signTime = params.signTime;
                this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/active-sign/create`, params).then((res) => {
                  if (res.code == 0) {
                    this.ResetSearch(["searchValue"]);
                    this.$message.success("签到成功");
                    this.personVisible = false;
                    this.initPersonData(
                      `Active_Enroll?activeId=${this.$route.params.id}`
                    );
                  } else {
                    this.$message.error(res.status);
                  }
                });
              }
            } else {
              let params = {
                enrollName: this.personForm.enrollName,
                enrollCompany: this.personForm.enrollCompany,
                enrollPosition: this.personForm.enrollPosition,
                enrollPhone: this.personForm.enrollPhone,
                enrollEmail: this.personForm.enrollEmail,
                enrollRemark: this.personForm.enrollRemark,
                activeId: this.personForm.activeId,
                isRegister: this.personForm.isRegister,
                isEnroll: this.personForm.isEnroll,
                enrollTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
                isSign: this.personForm.isSign,
                signTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
              };
              if (params.isEnroll == 2) {
                delete params.enrollTime;
              }
              if (params.isSign == 2) {
                delete params.signTime;
              }
              // if (params.isEnroll == 1 && this.typeStatus === "1") {
              if (this.typeStatus === "1") {
                params.id = this.personForm.id;
                this.http
                  .post(`${urlConfig.devUrl}apij2/admin-api/trade/active-enroll/update`, params)
                  .then((res) => {
                    if (res.code == 0) {
                      this.ResetSearch(["searchValue"]);
                      this.$message.success("修改成功");
                      this.personVisible = false;
                      this.initPersonData(
                        `Active_Enroll?activeId=${this.$route.params.id}`
                      );
                    }
                  });
              }
              // if (params.isSign == 1 && this.typeStatus != "1") {
              if (this.typeStatus != "1") {
                params.id = this.personForm.id;
                
                this.http
                  .post(`${urlConfig.devUrl}apij2/admin-api/trade/active-sign/update`, params)
                  .then((res) => {
                    if (res.code == 0) {
                      this.ResetSearch(["searchValue"]);
                      this.$message.success("修改成功");
                      this.personVisible = false;
                      this.initPersonData(
                        `Active_Enroll?activeId=${this.$route.params.id}`
                      );
                    }
                  });
              }
            }
          }
        } else {
          // console.log("error submit!!");
          this.is_submit = true;
          return false;
        }
      });
    },
    handleCurrentChange(e) {
      this.current_page = e;

      if (this.typeStatus === "1") {
        this.initPersonData(
          `Active_Enroll?activeId=${this.$route.params.id}&page=${this.current_page}&enrollName=${this.searchValue}`
        );
      } else {
        this.initPersonData(
          `Active_Sign?activeId=${this.$route.params.id}&page=${this.current_page}&sign_name=${this.searchValue}`
        );
      }
    },
    // 列表信息
    initPersonData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })

      }
      url = `${urlConfig.devUrl}apij2/admin-api/trade/active-enroll/page`;
      if (this.typeStatus != "1"){
        url = `${urlConfig.devUrl}apij2/admin-api/trade/active-sign/page`;
      }
      this.http.post(url, params)
        .then((res) => {
          this.tableData = res.data.data;
          this.current_page = res.data.current_page;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    search() {
      if (this.typeStatus === "1") {
        this.initPersonData(
          `Active_Enroll?activeId=${this.$route.params.id}&enrollName=${this.searchValue}`
        );
      } else {
        this.initPersonData(
          `Active_Sign?activeId=${this.$route.params.id}&signName=${this.searchValue}`
        );
      }
    },
  },
  created() {
    this.is_show = this.$route.query.is_show;
    this.isEnroll = this.$route.query.isEnroll;
    this.page_activeId = this.$route.params.id;
    this.initPersonData(`Active_Enroll?activeId=${this.$route.params.id}`);
  },
};
</script>

<style lang="scss">
@include component(active-detail) {
  width: 100%;
  height: 100%;
  @include part(header) {
    display: flex;
    justify-content: flex-start;
    @include component(el-input) {
      width: 300px;
    }
    section {
      margin-left: 50px;
    }
  }
  @include part(searchBtn) {
    margin-left: 10px;
    margin-right: 30px;
  }
  @include part(addBtn) {
    margin-left: 30px;
  }
  @include part(table) {
    margin-top: 30px;
  }
}
</style>
